<template>
    <form
        @submit.prevent="login"
        :action="urls.login"
        method="post"
        class="card border-2 border-sky-500 space-y-4"
    >
        <div class="py-4 space-y-4">
            <h1 class="text-2xl text-center text-gray-800 uppercase font-semibold">Login</h1>
            <div class="w-12 mx-auto border-b-2 border-gray-300"></div>
        </div>

        <text-input
            label="Email"
            v-model="form.email"
            :error="form.errors.email"
            placeholder="kevin.flynn@encom.com"
        />

        <text-input
            label="Password"
            v-model="form.password"
            :error="form.errors.password"
            type="password"
            placeholder="Password"
        />

        <div class="flex justify-between items-start space-x-4">
            <label for="remember_me" class="flex-1 flex items-center">
                <input
                    v-model="form.remember"
                    :false-value="null"
                    id="remember_me"
                    type="checkbox"
                    class="rounded border-gray-300 text-emerald-500 focus:ring focus:ring-emerald-500"
                    name="remember"
                >
                <span class="flex-1 ml-2 text-sm text-gray-600">Remember me</span>
            </label>

            <a class="flex-1 underline text-right text-sm text-gray-600 hover:text-gray-900" :href="urls.forgot_password">
                Forgot your password?
            </a>
        </div>

        <loading-button
            :loading="form.processing"
            class="btn btn-green w-full"
            type="submit"
        >
            Login
        </loading-button>

        <div class="underline text-center text-gray-600 hover:text-gray-900">
            <a href="/register">Don't have an account?</a>
        </div>

    </form>
</template>

<script setup>
import useForm from '@/functions/useForm'

const props = defineProps({
    urls: {
        type: Object,
        required: true
    }
})

const form = useForm({
    email: '',
    password: '',
    remember_me: false,
})

const login = () => {
    form.post(props.urls.login)
}
</script>
